import ListProcesses from "@/views/agro_exporter/finances/harvested_batch_outcomes/ListProcesses.vue";
import ShowProcess from "@/views/agro_exporter/finances/harvested_batch_outcomes/ShowProcess.vue";
import NewInvoice from "@/views/agro_exporter/finances/harvested_batch_outcomes/NewInvoice.vue";
import ShowOrgInvoice from "@/views/agro_exporter/finances/harvested_batch_outcomes/ShowOrgInvoice.vue";
import EditInvoice from "@/views/agro_exporter/finances/harvested_batch_outcomes/EditInvoice.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ae",
  role: "finances",
  permission: "harvested_batch_outcomes"
});

export default [
  {
    path: "/ae/:agro_exporter_id/finances/harvested_batch_outcomes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/ae/:agro_exporter_id/finances/harvested_batch_outcomes/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/finances/harvested_batch_outcomes/show_process/:agro_exporter_process_id",
    name: routeName("show_process"),
    component: ShowProcess,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/finances/harvested_batch_outcomes/new_invoice/:agro_exporter_process_id",
    name: routeName("new_invoice"),
    component: NewInvoice,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/finances/harvested_batch_outcomes/show_invoice/:agro_exporter_process_id/:org_invoice_id",
    name: routeName("show_invoice"),
    component: ShowOrgInvoice,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/finances/harvested_batch_outcomes/edit_invoice/:agro_exporter_process_id/:org_invoice_id",
    name: routeName("edit_invoice"),
    component: EditInvoice,
    props: true,
    meta: META
  }
]
